import { useContext, useMemo } from 'react';
import { AuthContext } from '../auth';

export interface DefaultFilters {
  defaultPrescriberNames: string[];
  defaultPrescriberNpis: string[];
}

/**
 * Hook to extract default prescriber filters from the current user in AuthContext.
 * Returns default prescriber names and provider NPIs.
 */
export function useDefaultFilters(): DefaultFilters {
  const authContext = useContext(AuthContext);
  const providers = useMemo(
    () => authContext.user?.default_filters?.providers || [],
    [authContext.user?.default_filters?.providers],
  );

  const defaultPrescriberNames = useMemo(() => providers.map((p) => p.name), [providers]);
  const defaultPrescriberNpis = useMemo(() => providers.map((p) => p.npi), [providers]);
  return { defaultPrescriberNames, defaultPrescriberNpis };
}
